import { render, staticRenderFns } from "./AnalyticsLegend.vue?vue&type=template&id=68c89aba&scoped=true&"
import script from "./AnalyticsLegend.vue?vue&type=script&lang=js&"
export * from "./AnalyticsLegend.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsLegend.vue?vue&type=style&index=0&id=68c89aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c89aba",
  null
  
)

export default component.exports